'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import isEqual from 'lodash/isEqual';
import {
  IDialInCountriesTableContextValue,
  IDialInCountryFormValue,
  IDialInCountryOption,
} from './interfaces';
import { IDialInCountry } from '@evercall/domain/vo/DialInCountry';
import {
  IFinalFormFieldArrayInputComponentProps,
} from '@framework/ui/Organisms/FinalForm/interfaces';

export const DialInCountriesTableContext = createContext<IDialInCountriesTableContextValue>(null);

export const useDialInCountriesTableContext = () => {
  const context = useContext(DialInCountriesTableContext);
  if (!context) {
    throw new Error('useDialInCountriesTableContext must be used within the DialInCountriesTableContext');
  }
  return context;
};

export interface IProps extends IFinalFormFieldArrayInputComponentProps<IDialInCountryFormValue> {
  children: React.ReactNode,
  countryList: Array<IDialInCountry>,
  disabled: boolean,
}

const DialInCountriesTableContextProvider = (
  {
    children,
    countryList,
    disabled,
    fields,
  }: IProps,
) => {
  const [countryOptions, setCountryOptions] = useState<Array<IDialInCountryOption>>([]);

  useEffect(
    () => {
      if (countryList.length && fields.value) {
        setCountryOptions(countryList.map(
          (country) => (
            {
              label: country.name,
              value: country.id,
              countryCode: country.code,
              phoneCode: country.phoneCode || '',
              disabled: !!fields.value.find((option) => isEqual(country.id, option.countryId?.value)),
            }
          ),
        ));
      }
    },
    [fields.value, countryList],
  );

  const contextProviderValue = {
    countryOptions,
    disabled,
    fields,
  };

  return (
    <DialInCountriesTableContext.Provider value={ contextProviderValue }>
      { children }
    </DialInCountriesTableContext.Provider>
  );
};

export default DialInCountriesTableContextProvider;
